<template>
  <div class="forgot-page">
    <div v-if="isFotgotPasswordOtp()" class="forgot">
      <div class="top"></div>
      <div class="otp">
        <div style="height: 20px;"></div>
        <h1 style="text-align: center">パスワードを忘れた方</h1>
        <div style="height: 40px;">
          <div v-if="logForgotPass" style="color: red;font: bold; text-align: center;font-size:20px;height: 30px; ">
            電話番号が必須です
          </div>
        </div>
        <div class="HintMessage">
          <img src="@/assets/images/avatar1@2x.png" width="50px">
          <h4 style="margin-top: -30px;display: inline-block; color: green;">ロコ子</h4>
          <div style="margin-left: 65px; margin-top: -30;">
            <img src="@/assets/images/img_conversation_top_left_green.png" width="250px" height="90vh"
              style=" position: absolute;display: inline-block;">
            <div
              style="position: relative; z-index: 1; max-width: 210px; margin-left: 20px; margin-top: 15px; display: inline-block;">
              ショートメッセージ（SMS）に認証番号を送ります。携帯番号を入力してください。
            </div>
          </div>
        </div>
        <p style="color: red; font: bold; margin-top: 65px; margin-left: 150px;"></p>
        <div style="width: 310px; margin-left: 150px; background-color:#9AC143; padding: 15px;margin-top: 35px ;">
          <label for="phoneNumber" class="white-text">携帯番号</label>
          <input type="text" id="phoneNumber" v-model="phoneNumber" @input="removeError()"
            @keyup.enter="sentFotgotPasswor" placeholder="例：08000000000" class="white-text"
            style="margin-left: 55px;  border-radius: 4px; height: 40px; background-color: rgb(175, 169, 162);" />
        </div>
        <div class="HintMessage">
          <img src="@/assets/images/avatar1@2x.png" width="50px">
          <h4 style="margin-top: -30px;display: inline-block; color: green;">ロコ子</h4>
          <div style="margin-left: 65px; margin-top: -30;">
            <img src="@/assets/images/img_conversation_top_left_green.png" width="250px" height="65vh"
              style=" position: absolute;display: inline-block;">
            <div
              style="position: relative; z-index: 1; max-width: 220px; margin-left: 20px; margin-top: 15px; display: inline-block;">
              SMSの受信拒否などをされている場合、解除をお願いいたします。
            </div>
          </div>
        </div>
      </div>
      <div class="button">
        <button @click="sentFotgotPasswor"
          style="background-color: #76a01d; color: #ffffff;padding: 10px;margin-bottom: 30px; border-color: #8fc31f;width: 100%; height: 100%; border: 10px; border-radius: 10px;margin: 0 auto;">
          次へ
        </button>
      </div>
    </div>
    <div v-if="isVerifyOtp()" class="forgot">
      <div class="top"></div>
      <div class="otp">
        <div style="height: 20px;"></div>
        <h1 style="text-align: center;color: green; margin-top: 30px;">SMSの確認をしてください</h1>
        <div style="text-align: center;font-size:18px;height: 30px; margin-top: 30px;">
          この携帯番号に送信された6桁のコード
        </div>
        <div style="text-align: center;font-size:24px;height: 30px; margin-top: 30px; color: green; font-weight: 600;">
          {{ phoneShow }}
        </div>
        <div style="height: 70px;">
          <div v-if="verificationResult" style="color: red;font: bold; text-align: center;font-size:20px;height: 30px;">
            認証コードが無効です。もう一度試してください。
          </div>
          <div v-if="resend" style="color: green;font: bold;text-align: center;font-size:20px;height: 30px;">
            認証コードが再度送信されました
          </div>
          <div v-if="resendError" style="color: red;font: bold; text-align: center;font-size:20px;height: 30px;">
            60秒お待ちください
          </div>
        </div>
        <div class="otp-container">
          <input type="text" ref="otp1" id="otp1" maxlength="1" @input="moveFocus(1, $event)" v-model="otp[0]"
            @keydown="handleBackspace(1, $event)" @keypress="isNumber($event)">
          <input type="text" ref="otp2" id="otp2" maxlength="1" @input="moveFocus(2, $event)" v-model="otp[1]"
            @keydown="handleBackspace(2, $event)" @keypress="isNumber($event)">
          <input type="text" ref="otp3" id="otp3" maxlength="1" @input="moveFocus(3, $event)" v-model="otp[2]"
            @keydown="handleBackspace(3, $event)" @keypress="isNumber($event)">
          <input type="text" ref="otp4" id="otp4" maxlength="1" @input="moveFocus(4, $event)" v-model="otp[3]"
            @keydown="handleBackspace(4, $event)" @keypress="isNumber($event)">
          <input type="text" ref="otp5" id="otp5" maxlength="1" @input="moveFocus(5, $event)" v-model="otp[4]"
            @keydown="handleBackspace(5, $event)" @keypress="isNumber($event)">
          <input type="text" ref="otp6" id="otp6" maxlength="1" @input="moveFocus(6, $event)" v-model="otp[5]"
            @keydown="handleBackspace(6, $event)" @keypress="isNumber($event)" @keyup.enter="verifyOTP">
        </div>
        <div style="text-align: center; margin-top: 30px;">
          <span>{{ formattedCountdown }}</span> 秒後に
          <div @click="handleResendOTP" style="cursor: pointer;display: inline-block; color: green;">再送信</div>
        </div>
      </div>
      <div class="button">
        <button @click="verifyOTP"
          style="background-color: #76a01d; color: #ffffff;padding: 10px;margin-bottom: 30px; border-color: #8fc31f;width: 100%; height: 100%; border: 10px; border-radius: 10px;margin: 0 auto;">
          送信
        </button>
      </div>
    </div>
    <div v-if="isReSetPass()" class="forgot">
      <div class="top"></div>
      <div class="otp">
        <div style="height: 20px;"></div>
        <h1 style="text-align: center">パスワード再設定</h1>
        <div style="height: 40px;">
          <div v-if="logForgotPass" style="color: red;font: bold; text-align: center;font-size:20px;height: 30px; ">
            携帯電話番号が存在しません
          </div>
        </div>
        <div class="HintMessage">
          <img src="@/assets/images/avatar1@2x.png" width="50px">
          <h4 style="margin-top: -30px;display: inline-block; color: green;">ロコ子</h4>
          <div style="margin-left: 65px; margin-top: -30;">
            <img src="@/assets/images/img_conversation_top_left_green.png" width="250px" height="90vh"
              style=" position: absolute;display: inline-block;">
            <div
              style="position: relative; z-index: 1; max-width: 210px; margin-left: 20px; margin-top: 15px; display: inline-block;">
              お客様でパスワードを再設定していただきます。新しいパスワードを入力してください。
            </div>
          </div>
        </div>
        <div
          style="display: flex ; width: 410px; margin-left: 50px; background-color:#9AC143; padding: 10px;margin-top: 35px ;">
          <label class="text-label">新しいパスワード</label>
          <input class="form-control" :class="!isShowPassword ? 'hide' : ''" autocomplete="off" ref="input"
            placeholder="英数半角8桁入力" id="input-1" v-model="password" maxlength="128" type="text"
            style="height: 40px; margin-left: 65px;" :maxlength="128" />
        </div>
        <div
          style="display: flex ; width: 410px; margin-left: 50px; background-color:#9AC143; padding: 10px;margin-top: 1px ;">
          <label class="text-label">新しいパスワード (確認用)</label>
          <input class="form-control" :class="!isShowPassword ? 'hide' : ''" autocomplete="off" ref="input"
            placeholder="英数半角8桁入力" id="input-2" v-model="confirmPassword" maxlength="128" type="text"
            style="height: 40px; margin-left: 1px;" :maxlength="128" @keyup.enter="reSetPass" />
        </div>

        <div style="margin-top: 20px; width: 150px; color: #76a01d; margin-left: 10px;" @click="showHide()">
          <u v-if="!isShowPassword">パスワードを表示　</u>
          <u v-else>パスワードを非表示</u>
        </div>
        <div style="margin-left: 60px;">
          <div class="text-danger mt-1" v-if="!this.passPassword() && password != ''">
            <div>パスワードの設定について</div>
            <div>・8-128文字の英数字を使用してください 例)test1234</div>
            <div>・特殊記号は含まない</div>
          </div>
          <div class="text-danger mt-1" v-if="passConfirmPassword()">
            <div>パスワードが一致しません。もう一度お試しください。</div>
          </div>
        </div>
      </div>
      <div class="button">
        <button @click="reSetPass" :disabled="disabled()" class="custom-button-resetpass">
          送信
        </button>
      </div>
    </div>
    <Footer class="custom-footer" v-custom-footer />
  </div>
</template>

<script>
import api from "@/api/";
import Footer from "@/components/footer";
import { mixin } from "@/helpers/Vue-Mixin";

const STEPS = {
  fotgotPasswordOtp: 1,
  verifyOtp: 2,
  reSetPass: 3
};

export default {
  directives: {
    'custom-footer': {
      inserted(el) {
        el.style.removeProperty('position');
      },
    },
  },
  data() {
    return {
      phoneNumber: '',
      otp: [],
      token: '',
      password: "",
      confirmPassword: "",
      logForgotPass: false,
      step: STEPS.fotgotPasswordOtp,
      verificationResult: false,
      resend: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
      countdown: 60,
      resendError: false,
      phoneShow: '',
    };
  },
  mixins: [mixin],
  components: {
    Footer
  },

  computed: {
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  },

  mounted() {
    this.$nextTick(() => {
      const inputElement = document.getElementById("phoneNumber");
      if (inputElement) {
        inputElement.focus();
      }
    });
  },

  methods: {

    isNumber(event) {
      const key = event.key;
      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    },

    moveFocus(position, event) {
      const value = event.target.value;
      if (value.length === 1 && position < 6) {
        this.$refs[`otp${position + 1}`].focus();
      }
      if (value.length === 0 && position > 1) {
      }

      this.verificationResult = false;
    },

    handleBackspace(position, event) {
      const key = event.key;
      if (key === 'Backspace' && this.otp[position - 1] === '' && position > 1) {
        this.$refs[`otp${position - 1}`].focus();
      }
      if (key === 'Backspace' && this.otp[position - 1] !== '') {
        this.otp[position - 1] = '';
      }
    },
    startCountdown() {
      this.countdown = 60;
      const interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },

    formattedMobile() {
      if (this.phoneNumber.length === 10) {
        this.phoneShow = `${this.phoneNumber.slice(0, 3)}-${this.phoneNumber.slice(3, 6)}-${this.phoneNumber.slice(6)}`;
      } else if (this.phoneNumber.length === 11) {
        this.phoneShow = `${this.phoneNumber.slice(0, 3)}-${this.phoneNumber.slice(3, 7)}-${this.phoneNumber.slice(7)}`
      } else {
        this.phoneShow = this.phoneNumber;
      }
    },

    handleResendOTP() {
      if (this.countdown === 0) {
        this.resendOTP();
        this.resendError = false;
      } else {
        this.resendError = true;
        setTimeout(() => {
          this.resendError = false;
        }, 3000);
      }
    },

    async sentFotgotPasswor() {
      try {
        const response = await api.sentFotgotPasswordOtp(this.phoneNumber, 'hospital')
        if (response.status === 200) {
          this.showVerifyOTP();
          this.formattedMobile();
          this.startCountdown();
          this.$nextTick(() => {
            const inputElement = document.getElementById("otp-focus");
            if (inputElement) {
              inputElement.focus();
            }
          });
        }
      } catch (error) {
        this.logForgotPass = true;
        throw error;
      }
    },
    async verifyOTP() {
      const otpString = this.otp.join('');
      try {
        const response = await api.verifyForgotPassWordOtp(this.phoneNumber, otpString)
        if (response.status === 200) {
          this.token = response.data.token;
          this.showReSetPass()
          this.$nextTick(() => {
            const inputElement = document.getElementById("input-1");
            if (inputElement) {
              inputElement.focus();
            }
          });
        }
      } catch (error) {
        this.verificationResult = true;
        throw error;
      }
    },
    async resendOTP() {
      const response = await api.sentFotgotPasswordOtp(this.phoneNumber, 'hospital')
      if (response.status === 200) {
        this.resend = true;
        setTimeout(() => {
          this.resend = false;
        }, 3000);
      }
    },
    async reSetPass() {
      try {
        const response = await api.resetPassword(this.token, this.password)
        if (response.status === 200) {
          this.confirm(
            {
              title: "",
              text: "パスワードが変更できました。",
              icon: "success",
              confirmButtonColor: "#8FC31F",
              confirmButtonText: "OK",
            },
            async (e) => {
              // eslint-disable-next-line no-console
              if (e.isConfirmed) {
                window.toastr.success("ログアウトに成功しました");
                setTimeout(() => this.$router.push("/login"), 50);
              }
            }
          );
        }
      } catch (error) {
        throw error;
      }
    },
    isFotgotPasswordOtp() {
      return this.step === STEPS.fotgotPasswordOtp;
    },
    showVerifyOTP() {
      this.step = STEPS.verifyOtp;
    },
    isVerifyOtp() {
      return this.step === STEPS.verifyOtp;
    },
    showReSetPass() {
      this.step = STEPS.reSetPass;
    },
    isReSetPass() {
      return this.step === STEPS.reSetPass;
    },
    removeError() {
      this.logForgotPass = false;
      this.verificationResult = false;
    },
    showHide() {
      this.isShowPassword = !this.isShowPassword;
    },
    passPassword() {
      return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,128}$/.test(this.password);
    },
    passConfirmPassword() {
      return (this.password !== this.confirmPassword) && this.confirmPassword !== ''
    },
    disabled() {
      return !(
        this.passPassword() &&
        !this.passConfirmPassword()
      )
    }
  }
};
</script>

<style>
.custom-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  padding: 10px;
}

::v-deep .footer {
  position: fixed !important;
}

.forgot-page {
  width: 100%;
  height: 100vh;
  background-color: #9AC143;
}

.forgot {
  background-color: #9AC143;
  min-height: 800px;
}

.top {
  height: 9vh;
}

.otp {
  width: 470px;
  height: 570px;
  background-color: #ffffff;
  border-radius: 10px;
  margin: 0 auto;
}

.button {
  width: 470px;
  height: 60px;
  margin: 20px auto;
}

.HintMessage {
  display: inline-block;
  margin-left: 10px;
}

.hide {
  -webkit-text-security: disc;
}

.custom-button-resetpass {
  background-color: #76a01d;
  color: #ffffff;
  padding: 10px;
  margin-bottom: 30px;
  border-color: #8fc31f;
  width: 100%;
  height: 100%;
  border: 10px;
  border-radius: 10px;
  margin: 0 auto;
}

.custom-button-resetpass:disabled {
  background-color: #999999;
  cursor: not-allowed;
}

.form-control {
  width: 200px;
}

.text-label {
  font-size: 15px;
  padding-top: 10px;
  color: green;
}

.otp-container {
  width: 100%;
  text-align: center;
}

.otp-container input {
  width: 40px;
  padding: 10px;
  margin: 5px;
  text-align: center;
  font-size: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: green
}

.otp-container input:focus {
  border-color: green !important;
  color: green !important;
  outline: none !important;
}
</style>
